/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface DateI {
    day: string,
    weekday: string
    month: string,
    year: string,
    hour: string,
    hourFormat: string,
    minutes: string,
    seconds: string
};

interface Options {
    date?: string | number | Date
    typeMonth?: "long" | "short" | "number",
    formatHour?: 24 | 12
}

export const useDateAsString = (date?: string | number, typeMonth?: "long" | "short"):[parseDate: string, updateDate: (date: string | number) => void] => {
    const [d, setDate] = useDate({date: date, typeMonth: typeMonth});
    const updateDate = (date: string | number) => {
        setDate(date);
    };
    return [`${d.day} ${d.month}, ${d.year}`, updateDate];
};

export const useDate = (options?: Options):
    [parseDate: DateI, updateDate: (date: string | number | Date) => void] => {
    const [dateP, setDate] = useState<string | number | Date | undefined>(options?.date);
    const [parseDate, setParseDate] = useState<DateI>({day: "", weekday: "", month: "", year: "", hour: "", hourFormat: "", minutes: "", seconds: ""});
    const { t } = useTranslation(["calendar"]);

    const updateDate = useCallback((date: string | number | Date) => {
        setDate(date);
    }, []);

    const getHourByFormat = (hour: string) => {
        if(options?.formatHour) {
            if(options.formatHour === 24) {
                return [hour, "hrs"];
            } else {
                if(Number(hour) > 12) {
                    return [Number(hour) - 12, "pm"];
                } else if(Number(hour) === 12){
                    return [Number(hour), "pm"];
                } else {
                    return [Number(hour), "am"];
                }
            }
        } else {
            return [hour, "hrs"];
        }
    };

    useEffect(() => {
        let dateISO = new Date();

        if(dateP) dateISO = new Date(dateP);

        const newDate = dateISO.toString().split(" ");
        const [hourParse, format] = getHourByFormat(newDate[4]?.split(":")[0]);
        const parseDate: DateI = {
            day: newDate[2],
            weekday: t(`calendar:days.${dateISO.getDay()}.short`),
            month: options?.typeMonth === "number" ? `${(dateISO.getMonth() + 1) <= 9 ? `0${dateISO.getMonth() + 1}` : `${dateISO.getMonth() + 1}`}` : t(`calendar:monthsAbbreviated.${newDate[1].toUpperCase()}.${options?.typeMonth? options?.typeMonth : "short"}`),
            year: newDate[3],
            hour: String(hourParse),
            hourFormat: String(format),
            minutes: newDate[4]?.split(":")[1],
            seconds: newDate[4]?.split(":")[2],
        };
        setParseDate(parseDate);
    }, [dateP, t]);
    return [parseDate as DateI, updateDate];
};
